import React, { useMemo } from 'react';
import classNames from 'classnames';
import { Img } from '@/components/atoms/Img';
import styles from './index.module.scss';

export interface AvatarProps {
  readonly src: string;
  readonly name: string;
  readonly className?: string;
  readonly size?: 'small' | 'large';
}

export function Avatar({ src, name, size = 'small', className, ...props }: AvatarProps): JSX.Element {
  const sizeLengthInPx = useMemo(() => {
    if (size === 'large') {
      return 100;
    }
    return 50;
  }, [size]);

  return (
    <Img
      provider="cloudinary"
      className={classNames(Avatar.displayName, styles.Avatar, size, className)}
      src={src}
      alt={name}
      width={sizeLengthInPx}
      height={sizeLengthInPx}
      {...props}
    />
  );
}
Avatar.displayName = 'Avatar';
